import React from "react";
import { Button } from "antd";
import { FaFirstAid } from "react-icons/fa";
import { TagBadge } from "./TagBadge";
import { getColorStyles, getDateString } from "../../../Utils/calendar_utils";
import { useSelector } from "react-redux";

export const DateCellContent = ({
  date,
  info,
  onClick = () => {},
  showGameAndTraining,
  fontSize = 11,
  popOutView = false
}) => {
  const {
    info: { display_name: teamName, difficulty_bar_config: difficultyBarConfig },
  } = useSelector(({ team }) => team);

  const dateString = getDateString(date);

  if (!info) {
    return (
      <div style={{ position: "relative", width: "100%", height: "100%" }}>
        <Button className="no-training-day-btn">
          <TagBadge dateString={dateString} />
        </Button>
      </div>
    );
  }

  const { borderColor, fontColor, backgroundColor, background } =
    getColorStyles(info, difficultyBarConfig);

  const gameTraining = info.opponent ? "G" : "T";
  const score = info.score ? `${Math.round(info.score)}%` : gameTraining;

  return (
    <div
      onClick={() => onClick(date)}
      style={{ cursor: "pointer", height: "100%" }}
    >
      <Button
        style={{
          color: fontColor,
          background: background || backgroundColor,
          backgroundColor: backgroundColor,
          border: `${info["opponent"] ? 2 : 1}px solid ${borderColor}`,
          width: "100%",
          height: "80%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          fontSize,
          fontWeight: "bold",
        }}
      >
        <div>{!showGameAndTraining ? gameTraining : score}</div>
        {info["is_prediction"] && info.total_time === undefined && (
          <div style={{ position: "absolute", top: 0, right: 4, fontSize: "14px" }}>P</div>
        )}
        {info.injuries && info.injuries.length > 0 && (
          <FaFirstAid className="injury-icon" size={17} />
        )}
        <TagBadge dateString={dateString} popOutView={popOutView} />
      </Button>
    </div>
  );
};
